"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fail = fail;

var _debrief = require("debrief");

var _Result = require("lemons/Result");

/**
 * Decoder that always fails with the given error message, no matter what the input.
 */
function fail(msg) {
  return function (blob) {
    return (0, _Result.Err)((0, _debrief.annotate)(blob, msg));
  };
}